import axios from "axios";
let instance = axios.create( {
    baseURL: process.env.REACT_APP_API_SERVER_URL,
    timeout: 100000,
    headers: {
        "Content-Type": "Application/json",
    }
})
// READ
export function gerOrder(identifier) {
    return instance.get(`${process.env.REACT_APP_API_SERVER_URL}/front/`)
}

// READ
export function getOrderForm(orderKey) {
    // TODO : k1order_store -> ${orderKey}
    return instance.get(`${process.env.REACT_APP_API_SERVER_URL}/front/orderkey?order_key=${orderKey}`)
}

// READ
export function getOrderWizardForm(orderKey, formIdx) {
    // k1order_store -> ${orderKey}
    return instance.get(`${process.env.REACT_APP_API_SERVER_URL}/front/orderform2?order_key=${orderKey}&form_idx=${formIdx}`)
}

// CREATE
export function createOrder(data) {
    return instance.post(`${process.env.REACT_APP_API_SERVER_URL}/front/order`, data,   {headers:{'content-type': 'multipart/form-data'}})
}

// UPDATE
export function updateOrder(data) {
    return instance.patch(`${process.env.REACT_APP_API_SERVER_URL}/front/order/status`,data)
}

// UPDATE2
export function updateOrder2(data) {
    return instance.patch(`${process.env.REACT_APP_API_SERVER_URL}/front/order`,data)
}

// ACCOUNT READ
export function getAccountInfo(idx, form_idx) {
    const url = new URL(`${process.env.REACT_APP_API_SERVER_URL}/front/store/accountinfo`)
    url.searchParams.append('store_idx', idx)
    if (form_idx) {
        url.searchParams.append('form_idx', form_idx)
    }
    return instance.get(url.toString())
}

// QNA READ
export function getQNA(idx) {
    return instance.get(`${process.env.REACT_APP_API_SERVER_URL}/front/qnas?t_orderidx=${idx}`)
}

// QNA CREATE
export function createQNA(qna) {
    return instance.post(`${process.env.REACT_APP_API_SERVER_URL}/front/qna`,qna)
}

// QNA UPDATE
export function updateQNA(qna) {
    return instance.put(`${process.env.REACT_APP_API_SERVER_URL}/front/qna`,qna)
}

// QNA DELETE
export function deleteQNA(idx) {
    return instance.delete(`${process.env.REACT_APP_API_SERVER_URL}/front/qna?idx=${idx}`)
}

// FAQ LIST READ
export function getFAQList(idx) {
    return instance.get(`${process.env.REACT_APP_API_SERVER_URL}/front/faq?t_storeidx=${idx}`)
}

// FAQ DATA READ
export function getFAQData(t_storeidx, t_boardidx) {
    return instance.get(`${process.env.REACT_APP_API_SERVER_URL}/front/faq?t_storeidx=${t_storeidx}&t_boardidx=${t_boardidx}`)
}

// FAQ COUNT UPDATE
export function updateFAQCount(idx) {
    return instance.patch(`${process.env.REACT_APP_API_SERVER_URL}/front/faq/count?t_boardidx=${idx}`);
}



// PAYMENT RESULT
export function paymentResult(method, result, data) {
    return instance.post(`${process.env.REACT_APP_API_SERVER_URL}/front/payment/${method}/${result}`,data)
}